/**
 * Plan options for the plan selector dropdown
 */
export const PLAN_OPTIONS = [
  { value: "ALL", label: "All" },
  { value: "COACH", label: "Coach Plans" },
  { value: "STUDENT", label: "Student Plans" },
  { value: "sportsbox_student_lite_monthly", label: "3D Player - Monthly" },
  { value: "sportsbox_student_lite_annually", label: "3D Player - Annual" },
  { value: "sportsbox_pro_lite_monthly", label: "Pro Lite - Monthly" },
  { value: "sportsbox_pro_lite_annually", label: "Pro Lite - Annual" },
  { value: "sportsbox_pro_plus_monthly", label: "Plus - Monthly" },
  { value: "sportsbox_pro_plus_annually", label: "Plus - Annual" },
  { value: "sportsbox_pro_premium_monthly", label: "3D Pro - Monthly" },
  { value: "sportsbox_pro_premium_annually", label: "3D Pro - Annual" },
  { value: "sportsbox_enterprise_master", label: "Enterprise Master" },
  { value: "sportsbox_enterprise_staff", label: "Staff Account" },
];

